import React from "react";
import { useState } from "react";
import { StripePayment } from "../../../../components/stripePayment";
import { LuCreditCard } from "react-icons/lu";
import { MdOutlineClose } from "react-icons/md";
import Divider from "../../../../components/shared/Divider/Divider";

const PlanCard = ({ onClick, mainText, secondaryText, isSelected }) => (
  <div
    className={`w-full flex flex-col items-center justify-center gap-2 rounded-lg p-2 cursor-pointer border ${
      isSelected ? "border-primary700 bg-primary50" : "border-gray300 bg-white"
    }`}
    onClick={onClick}
  >
    <div
      className={`text-sm font-semibold ${
        isSelected ? "text-primary700" : "text-gray700"
      }`}
    >
      {mainText}
    </div>
    <div
      className={`text-xs font-semibold ${
        isSelected ? "text-primary700" : "text-gray500"
      }`}
    >
      {secondaryText}
    </div>
  </div>
);

const PLANS = {
  studentCredits: [
    {
      mainText: "30 Months ($300)",
      secondaryText: "$10/monthly credit",
      amount: 300,
      credits: 30,
    },
    {
      mainText: "60 Months ($500)",
      secondaryText: "$8.33/monthly credit",
      amount: 500,
      credits: 60,
    },
    {
      mainText: "100 Months ($700)",
      secondaryText: "$7/monthly credit",
      amount: 700,
      credits: 100,
    },
    {
      mainText: "300 Months ($1800)",
      secondaryText: "$6/monthly credit",
      amount: 1800,
      credits: 300,
    },
  ],
  // reportCredits: [
  //   {
  //     mainText: "5 Reports ($250)",
  //     secondaryText: "$50/report",
  //     amount: 250,
  //     credits: 5,
  //   },
  //   {
  //     mainText: "10 Reports ($475)",
  //     secondaryText: "5% OFF - $48/report",
  //     amount: 475,
  //     credits: 10,
  //   },
  //   {
  //     mainText: "20 Reports ($900)",
  //     secondaryText: "10% OFF - $45/report",
  //     amount: 900,
  //     credits: 20,
  //   },
  //   {
  //     mainText: "30 Reports ($1,275)",
  //     secondaryText: "15% OFF - $42/report",
  //     amount: 1275,
  //     credits: 30,
  //   },
  //   {
  //     mainText: "40 Reports ($1,600)",
  //     secondaryText: "20% OFF - $40/report",
  //     amount: 1600,
  //     credits: 40,
  //   },
  //   {
  //     mainText: "50 Reports ($1,875)",
  //     secondaryText: "25% OFF - $38/report",
  //     amount: 1875,
  //     credits: 50,
  //   },
  // ],
};

export const CreditSelectForm = ({
  amount,
  credits,
  handlePackageChange,
  user,
  handleResult,
  onClose,
}) => {
  const plans = PLANS["studentCredits"];

  return (
    <div className="w-full h-full font-manrope">
      <div className="flex justify-between items-center">
        <div className="border border-gray200 rounded-md p-2">
          <LuCreditCard className="size-6 min-w-6 text-gray700" />
        </div>
        <MdOutlineClose
          onClick={onClose}
          className="size-6 min-w-6 text-gray500"
        />
      </div>

      <div className="mt-4 text-gray900 text-lg font-semibold">
        Payment method
      </div>
      <div className="mt-1 text-gray600 text-sm">Update your card details.</div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {plans.map((plan, index) => (
          <PlanCard
            key={index}
            mainText={plan.mainText}
            secondaryText={plan.secondaryText}
            onClick={() => handlePackageChange(plan.amount)}
            isSelected={amount === plan.amount && credits === plan.credits}
          />
        ))}
      </div>

      <div className="mt-4 text-center text-gray700 text-lg font-semibold">
        Amount: ${amount}
      </div>
      <div className="mt-2 text-center text-gray500 text-sm font-semibold">
        {credits} (months)
      </div>

      <Divider className="my-4" color="gray200" type="horizontal"/>

      {amount > 0 && (
        <StripePayment
          amount={amount}
          handleResult={handleResult}
          //useConfirmation={true}
          name={user?.userName}
          email={user?.email}
        />
      )}
      <div style={{ height: "20px" }}></div>
    </div>
  );
};
